import '.a{display:grid;}.ssr-plugin'
import '.ht{grid-template-columns:repeat(3, minmax(250px, 1fr));}.ssr-plugin'
import '.g{gap:1rem;}.ssr-plugin'
import { StoryCard } from '../../card/StoryCard'
import { pages } from '@app/util/links'
import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'
import { styled } from 'inlines'
import { StoredImage } from '@app/types/StoredImage'
import { AppearItem, useAppearStyle } from '../blocks/AppearInViewport'

export type StoriesContentSectionType = {
  type: 'stories'
  title: string
  items: {
    id: number
    slug: string
    title: string
    intro?: string
    images?: StoredImage[]
  }[]
}

const StoryCardItem = ({
  item,
  index,
}: {
  item: StoriesContentSectionType['items'][number]
  index: number
}) => {
  const appearStyle = useAppearStyle(index + 1)

  return (
    <StoryCard
      title={item.title}
      subtitle={item.intro}
      image={item.images?.[0]}
      to={pages.blog('verhalen', item.slug)}
      version={index}
      style={appearStyle}
    />
  )
}

export const StoriesContentSection = ({
  title,
  items,
}: StoriesContentSectionType) => {
  if (items.length === 0) return null

  return (
    <Column gap="0.5rem">
      <AppearItem staggerIndex={0}>
        <Title.H2>{title}</Title.H2>
      </AppearItem>
      <styled.div className="a ht g"
        style={{
          '@media (max-width: 1200px)': {
            gridTemplateColumns: 'repeat(2, minmax(250px, 1fr))',
          },
          '@media (max-width: 800px)': {
            gridTemplateColumns: 'repeat(1, minmax(250px, 1fr))',
          },}}
      >
        {items.map((item, index) => (
          <StoryCardItem key={item.id} item={item} index={index} />
        ))}
      </styled.div>
    </Column>
  )
}
